import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Home from './pages/Home';
import PrivacyQuest from './pages/PrivacyQuest';
import AlgorithmMirror from './pages/AlgorithmMirror';
import DataHeist from './pages/DataHeist';
import PhantomFootprint from './pages/PhantomFootprint';
import DeepfakeDetective from './pages/DeepfakeDetective';
import PermissionImpossible from './pages/PermissionImpossible';
import TermsTrial from './pages/TermsTrial';
import LeakLab from './pages/LeakLab';
import AuthCallback from './pages/AuthCallback';
import Subscribe from './pages/Subscribe';
import SubscribeSuccess from './pages/SubscribeSuccess';
import PrivacyNotice from './pages/PrivacyNotice';
import RequireAuth from './auth/RequireAuth';
import RequirePaid from './auth/RequirePaid';
import RequireOrgAdmin from './auth/RequireOrgAdmin';
import Portal from './pages/Portal';

export default function App() {
  return (
    <BrowserRouter>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Nav />
      <div style={{ flex: 1 }}>
      <Routes>
        <Route path="/"                   element={<Home />} />
        <Route path="/callback"           element={<AuthCallback />} />
        <Route path="/subscribe"          element={<Subscribe />} />
        <Route path="/subscribe/success"  element={<SubscribeSuccess />} />
        <Route path="/quest"     element={<RequireAuth><RequirePaid><PrivacyQuest /></RequirePaid></RequireAuth>} />
        <Route path="/algorithm" element={<RequireAuth><RequirePaid><AlgorithmMirror /></RequirePaid></RequireAuth>} />
        <Route path="/dataheist" element={<RequireAuth><RequirePaid><DataHeist /></RequirePaid></RequireAuth>} />
        <Route path="/phantom"   element={<RequireAuth><RequirePaid><PhantomFootprint /></RequirePaid></RequireAuth>} />
        <Route path="/detective"    element={<RequireAuth><RequirePaid><DeepfakeDetective /></RequirePaid></RequireAuth>} />
        <Route path="/permissions"  element={<RequireAuth><RequirePaid><PermissionImpossible /></RequirePaid></RequireAuth>} />
        <Route path="/trial"        element={<RequireAuth><RequirePaid><TermsTrial /></RequirePaid></RequireAuth>} />
        <Route path="/leaklab"      element={<RequireAuth><RequirePaid><LeakLab /></RequirePaid></RequireAuth>} />
        <Route path="/portal"    element={<RequireOrgAdmin><Portal /></RequireOrgAdmin>} />
        <Route path="/privacy"   element={<PrivacyNotice />} />
        <Route path="*"          element={<Navigate to="/" replace />} />
      </Routes>
      </div>
      <Footer />
      </div>
    </BrowserRouter>
  );
}
